import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";

interface GameInfoBtnProps {
  gameId: string;
}

function GameInfoBtn({ gameId }: GameInfoBtnProps) {
  const navigate = useNavigate();

  return (
    <Tooltip title="Game Details" placement="top">
      <IconButton
        onClick={() => {
          navigate(`/games/${gameId}`);
        }}
        color="info"
        size="small"
      >
        <InfoIcon />
      </IconButton>
    </Tooltip>
  );
}

export default GameInfoBtn;
